export default __webpack_public_path__ + "static/media/AllTickets.938b91dd.mp3";